import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useReadProfile = () => {

    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage } = useContext(MessageContext);
    const [ profile, setProfile ] = useState([]);
    const [ fetchingProfile, setFetchingProfile ] = useState(true);

    /** list contracts
    * @returns {object} - user profile */ 
    const readProfile = async (type) => {
        try {

            const msgId = addMessage({ type: "loading", header: t('general.moment'), body: t('info.fetchingProfile')});
            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();
            
            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);

            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/profile", options);

            removeMessage(msgId);

            if (result && result.status === 200 && result.data) {
                setProfile(result.data);
                setFetchingProfile(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.profileNotFound') });
                setFetchingProfile(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingProfileFailed') });
            setFetchingProfile(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingProfileFailed') });
            setFetchingProfile(false);
            return error;
        }
    }

    return { profile, fetchingProfile, readProfile };

}

export default useReadProfile;
